<template>
  <v-row dense class="text--primary mt-5">
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader class="grey lighten-2 text--primary font-weight-bold">
          Produtos
        </v-subheader>
        <v-divider/>
        <px-aprovacao-compra-produtos-table :aprovacao="aprovacao"
                                            @update="emitUpdate"
                                            show-estoque/>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import AprovacaoCompraProdutosTable
  from '@/modules/aprovacao-compra/components/AprovacaoCompraProdutosTable.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
    },
  },
  components: {
    pxAprovacaoCompraProdutosTable: AprovacaoCompraProdutosTable,
  },
};
</script>
